// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"1afeb7101b640d59","895":"bde01f7d76df312a","6321":"151dcac37132f953"}[chunkId] + ".css";
};